<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item">{{$t('Materials')}}</li>
        <li v-if="response.material" class="breadcrumb-item active" aria-current="page">{{ response.material.activitat_titol }}</li>
      </ol>
    </nav>

    <h1 v-if="response.material">{{response.material.activitat_titol}}</h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.material">

          <div class="card-body">

            <div class="m-t-20 row">

              <div class="col-md-2 col-xs-12 text-center mb-2">

                <a v-bind:href="response.material.activitat_original" target="_blank" rel="noreferrer noopener">
                  <img v-if="response.material.activitat_thumbnail" :src="response.material.activitat_thumbnail" @error="imageUrlAlt($event, response.material.activitat_rights)" alt="thumbnail" class="img-responsive float-left img-thumbnail">
                  <img v-else src="../../assets/images/no-thumbnail.png" alt="thumbnail" class="img-responsive float-left img-thumbnail rounded-0">
                </a>
              </div>

              <div class="col-md-10">

                <div>

                  <div class="row mb-2" v-if="response.material.activitat_professors">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('autors')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="(professor, index) in response.material.activitat_professors" :key="professor">
                        <div v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''">
                          <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                        </div>
                        <div v-else>
                          <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                            <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus document')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(response.material.activitat_subtipus_innovacio)}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_acronim">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Sigles')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_acronim}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_conference_edition_name">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nom de l\'edició')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_conference_edition_name}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_codisegonsentitatfinancadora">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Codi de entitat finançadora')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_codisegonsentitatfinancadora}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_financament">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Import')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$response.material.activitat_financament}} €</p>
                  </div>
                </div>



                <div class="row mb-2" v-if="response.material.activitat_revista_titol">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Revista')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(response.material.activitat_revista_titol)}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_modalitat">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Modalitat')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(response.material.activitat_modalitat)}}</p>
                  </div>
                </div>

                <div v-if="response.material.activitat_data_publicacio">
                  <div class="row mb-2">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data Publicació')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <p class="mb-1">{{response.material.activitat_data_publicacio}}</p>
                    </div>
                  </div>
                </div>


                <div>

                  <div v-if="response.material.activitat_data_inicio || response.material.activitat_data_fin">
                    <div class="row mb-2" v-if="response.material.activitat_data_inicio">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data d\'inici')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.activitat_data_inicio}}</p>
                      </div>
                    </div>

                    <div class="row mb-2" v-if="response.material.activitat_data_fin">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data de publicació')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.activitat_data_fin}}</p>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="row mb-2">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data (any)')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.data}}</p>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row mb-2" v-if="response.material.activitat_rights">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('rights')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      {{$t(response.material.activitat_rights)}}
                      <span class="mr-2"></span>
                      <i v-if="response.material.activitat_rights === 'Open Access'" class="fas fa-lock-open text-warning" :title="response.material.activitat_rights"></i>
                      <img v-else-if="response.material.activitat_rights === 'Restricted access to the UPC academic community'" src="../../assets/images/obertupc.png" :title="response.material.activitat_rights" alt="Restricted access to the UPC academic community">
                      <img v-else-if="response.material.activitat_rights === 'Restricted access to the CSUC academic community'" src="../../assets/images/obertupc.png" :title="response.material.activitat_rights" alt="Restricted access to the CSUC academic community">
                      <i v-else class="fas fa-lock text-warning" :title="response.material.activitat_rights"></i>
                    </p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_rights === 'Restricted access to the UPC academic community' || response.material.activitat_rights === 'Restricted access to the CSUC academic community'">
                  <div class="col-md-3 col-xs-12"></div>
                  <div class="col-md-9 col-xs-12">
                    <div class="alert alert-secondary" role="alert">
                      <span class="fw-bolder">{{ $t('banner rights restricted title') }}</span>
                      <span>{{ $t('banner rights restricted content') }}</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-2" v-else-if="response.material.activitat_rights === 'Open Access'">
                  <div class="col-md-3 col-xs-12"></div>
                  <div class="col-md-9 col-xs-12">
                    <div class="alert alert-secondary d-flex align-items-center" role="alert">
                      <!-- Columna de la imagen con tamaño fijo -->
                      <div class="me-3 flex-shrink-0">
                        <img src="../../assets/images/cc/by-nc-nd.png" alt="cc-by-nc-nd" title="cc-by-nc-nd" style="max-height: 50px;">
                      </div>

                      <!-- Columna del texto y enlace que ocupa el resto del espacio -->
                      <div class="flex-grow-1">
                        <span>{{ $t('banner rights open content') }}</span>
                        <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" rel="noopener noreferrer">
                          {{ $t('banner rights open link') }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_rights_uri != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Llicència')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1"><a v-bind:href="response.material.activitat_rights_uri" target="_blank" rel="noreferrer noopener">{{response.material.activitat_rights_uri}}</a> </p>
                  </div>
                </div>


                <div class="row mb-2" v-if="response.material.activitat_publisher != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Editorial')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_publisher}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_acts_book_name">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Llibre Actes')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_acts_book_name}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_pagina_inicial">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Pàgina inicial')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_pagina_inicial}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_pagina_final">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Pàgina final')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_pagina_final}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_volum">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Volum')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_volum}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_numero">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Número')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_numero}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_doi">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">DOI</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1"><a target="_blank" :href="`https://doi.org/${response.material.activitat_doi}`">{{response.material.activitat_doi}}</a></p>
                  </div>
                </div>

                <div v-if="response.material.activitat_projecte_nom">
                  <div class="row mb-2">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Projecte finançador')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="projecteFinancador in response.material.activitat_projecte_nom" v-bind:key="projecteFinancador">
                        <!--div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: projecteFinancador}}">{{projecteFinancador}}</router-link></div-->
                        <div class="mb-1">{{projecteFinancador}}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mb-2" v-if="response.material.activitat_version != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Versió')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_version}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_has_version != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Última versió')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      <router-link :to="{name: 'material', params: {id: response.material.activitat_has_version}}">{{response.material.activitat_has_version}}</router-link>
                    </p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_isbn">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">ISBN</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="isbn in response.material.activitat_isbn" v-bind:key="isbn">
                      <span class="mb-2">{{isbn}}</span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_dl">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Dipòsit legal')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{response.material.activitat_dl}}
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_centres">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centre Docent')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="centre in response.material.activitat_centres" v-bind:key="centre">
                      <span class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: centre}}">{{$t(centre)}}</router-link></span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_assignatures">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Assignatures')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="assignatura in response.material.activitat_assignatures" v-bind:key="assignatura">
                      <span class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura}}">{{$t(assignatura)}}</router-link></span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_titulacions">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="titulacio in response.material.activitat_titulacions" v-bind:key="titulacio">
                      <span class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}"><translate>{{$t(titulacio)}}</translate></router-link></span>
                    </div>
                  </div>
                </div>

                <hr v-if="response.material.activitat_urlWeb || response.material.activitat_urlRepo || response.material.activitat_urlEprints || response.material.activitat_resum || response.material.activitat_keywords">


                <div class="row mb-2" v-if="response.material.activitat_urlRepo">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Repositori')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="response.material.activitat_urlRepo" target="_blank" rel="noreferrer noopener">{{response.material.activitat_urlRepo}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_urlEprints">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Repositori')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="response.material.activitat_urlEprints" target="_blank" rel="noreferrer noopener">{{response.material.activitat_urlEprints}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_urlWeb">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('URL')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="response.material.activitat_urlWeb" target="_blank" rel="noreferrer noopener">{{response.material.activitat_urlWeb}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_resum">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Resum')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_resum[0]}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_keywords">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Keywords')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_keywords}}</p>
                  </div>
                </div>

                <hr v-if="response.material.activitat_entitat || response.material.activitat_fundingEntity || response.material.activitat_participantEntity">

                <div class="row mb-2" v-if="response.material.activitat_entitat">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Entitat desenvolupadora')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_entitat}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_fundingEntity">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Entitat financiadora')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="(fundingEntity) in response.material.activitat_fundingEntity" :key="fundingEntity">
                      <p class="mb-1">{{fundingEntity}}</p>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_participantEntity">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Entitat participant')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="(participantEntity) in response.material.activitat_participantEntity" :key="participantEntity">
                      <p class="mb-1">{{participantEntity}}</p>
                    </div>
                  </div>
                </div>

                <hr v-if="response.material.activitat_grups">

                <div class="row mb-1" v-if="response.material.activitat_grups">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Grups de recerca')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="grup in response.material.activitat_grups" v-bind:key="grup">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: grup}}">{{$t(grup)}}</router-link></div>
                    </div>
                  </div>
                </div>


              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <template v-if="response.material.id.startsWith('2099_') || response.material.id.startsWith('2117_')">
                    <img src="../../assets/images/mini-upc.svg" width="20" alt="UPCommons" class="me-1 d-none d-lg-block img-fluid">
                    <a class="me-4 d-none d-lg-block" :href="'http://hdl.handle.net/' + response.material.id.replace('_','/')" target="_blank" rel="noreferrer noopener">UPCommons <i class="fa-solid fa-external-link mini-icon"></i></a>
                  </template>
                  <template v-else>
                    <span class="me-4 d-none d-lg-block">&nbsp;</span>
                  </template>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Extracto Inteligente potenciado con IA -->
    <IntelligentExtractCard v-if="response.material?.id" :materialId="response.material.id" />

    <h2 v-if="response.material && response.material.activitat_professors" class="fw-bold mt-5">{{$t('participants')}}</h2>


    <div class="row" v-if="response.material">

      
      <div class="col-sm-12 col-md-12 mt-2 mx-3">
          <div v-for="(professor, index) in response.material.activitat_professors" :key="professor">
            <div v-if="professor.indexOf('##') === -1 ||professor.split('##')[1] === ''">
                <i class="fa-regular fa-user text-secondary fa-lg mb-4"></i> {{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})
            </div>
            <div v-else>
              <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                  <i class="fa-regular fa-user fa-lg mb-4"></i>
                  {{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})
              </router-link>
            </div>
          </div>
      </div>
    

      


      <h2 v-if="response.material.activitat_original" class="fw-bold mt-4">{{$t('Arxius')}}</h2>

      <div class="row" v-if="response.material.activitat_original">
        <div class="col-sm-12 col-md-12 mx-3">
          <div v-for="(arxiu) in response.material.activitat_original" :key="arxiu" class="mt-3">

            <a :href="arxiu" target="blank_" class="">
              <i class="fa-regular fa-file fa-lg"></i>
              {{decodeURIComponent(arxiu.split("/")[arxiu.split("/").length-1])}}
              <i class="fa-solid fa-external-link mini-icon"></i>
            </a>

          </div>
        </div>
      </div>

    </div>

    <!--div v-if="response.material">
      <div v-if="response.material.activitat_subtipus_innovacio == 'participacioProjecteInnovacioDocent'
              || response.material.activitat_subtipus_innovacio == 'participacioProjecteRDICompetitiu'
              || response.material.activitat_subtipus_innovacio == 'participacioProjecteRDINoCompetitiu'">

        <div class="small alert alert-danger" role="alert">
          MOSTRARIA LAS ACTIVIDADES ASOCIADAS (ARTICULOS Y TRABAJO EN CONGRESOS) DEL PROYECTO SELECCIONADO.<br>
          EN NUESTRO EN CASO ACTUAL NO HAY NINGUNO PORQUE NO HAY ARTICULOS NI TRABAJOS EN CONGRESOS ASOCIADOS A PROYECTOS
          DE DOCENCIA (TODOS SON DE RECERCA(
        </div>


      </div>

    </div-->

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import MaterialService from "@/services/MaterialService";
import {imageUrlAlt} from "@/utils/utils";
import IntelligentExtractCard from "@/components/IntelligentExtractCard.vue";

  export default {
    name: "ActivitatInnovacioView",
    methods: {imageUrlAlt},
    components: {RouterLinkLocale, IntelligentExtractCard},

    setup() {
      const response = ref([]);
      const responseMaterials = ref([]);
      const route = useRoute();

      const totalElements = ref(0)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");

      onMounted(async () => {
        const id = route.params.id;
        response.value = await MaterialService.getMaterial(id)
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
      });

      return {
        response,
        responseMaterials,

        selectedOrder,
        totalElements,
        pageSize
      }
    }
  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
